import config from '../../config';
import { authHeader } from '@/helpers';

export const userService = {
  login,
  register,
  getAll,
  getById,
  update,
  delete: _delete,
  changePassword,
  forgotPassword,
  resetPassword,
  stripeBillingCenter,
  subscribeToPlan,
  refresh,
  updateAddress,
  attachPaymentMethod,
  invoices
};

function login(identifier, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ identifier, password })
  };

  return fetch(`${config.apiUrl}/auth/local`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      return user;
    });
}

function refresh() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/me`, requestOptions)
    .then(handleResponse);
}

async function register({ user, member }) {

}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/me`, requestOptions).then(handleResponse);
}

function invoices() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/user/invoices`, requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/users/me`, requestOptions).then(handleResponse)
    .then(userUpdated => {
      return userUpdated;
    });
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/me`, requestOptions).then(handleResponse);
}

/**
 * https://strapi.io/documentation/3.x.x/guides/authentication.html#password-reset
 * @param data
 * @returns {Promise<Response | never>}
 */
function changePassword(data) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  };
  return fetch(`${config.apiUrl}/user/password`, requestOptions)
    .then(handleResponse);
}

function forgotPassword(email) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  };

  return fetch(`${config.apiUrl}/password/forgot`, requestOptions)
    .then(async response => {
      if (response.ok) {
        return true;
      }
      else {
        let data = await response.text();
        data = JSON.parse(data);
        if (data.message) {
          return data.message;
        }
        return true;
      }
    });
}

/**
 * https://strapi.io/documentation/3.x.x/guides/authentication.html#password-reset
 * @param data
 * @returns {Promise<Response | never>}
 */
function resetPassword(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  };
  return fetch(`${config.apiUrl}/password/change`, requestOptions)
    .then(handleResponse);
}

function stripeBillingCenter() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/billingCenter`, requestOptions).then(handleResponse);
}

function subscribeToPlan(plan) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ plan })
  };

  return fetch(`${config.apiUrl}/users/subscribe`, requestOptions).then(handleResponse);
}

function updateAddress(address) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(address)
  };

  return fetch(`${config.apiUrl}/user/address`, requestOptions).then(handleResponse);
}

function attachPaymentMethod(paymentMethod) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({
      paymentMethod
    })
  };

  return fetch(`${config.apiUrl}/user/paymentMethod`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }

      const error = data ? data.message || response.statusText : response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

